export const codespan = (text: string) => `<code>${text}</code>`
